module.exports = __webpack_public_path__ + "img/close-icon.00a4cb7d.svg";